export const memberProfile = {
  "verified": "Verified",
  "online": "Online",
  "memberSince": "Member since",
  "contact": "Contact",
  "share": "Share",
  "respondsIn": "Responds in",
  "responseRate": "response rate",
  "exchangesCompleted": "Exchanges completed",
  "reviews": "reviews",
  "responseRateLabel": "Response rate",
  "memberSinceLabel": "Member since",
  "years": "years",
  "year": "year",
  "exchangeHistory": "Exchange history",
  "property": "Property",
  "reviewsTab": "Reviews",
  "all": "All",
  "completed": "Completed",
  "upcoming": "Upcoming",
  "cancelled": "Cancelled",
  "exchangeWith": "Exchange with",
  "nights": "nights",
  "noExchangeInCategory": "No exchange in this category",
  "offeredProperty": "Offered property",
  "memberReviews": "Member reviews"
};
